import cn from 'classnames';
import { rm } from 'utils';
import { Button } from 'components/Button';
import IntegrityPolicyContent from '../../integrityPolicyModal';
import { CheckoutModal } from 'views/CheckoutPage/checkoutModal';
import { useToggle } from 'hooks';
import styles from './contactInfoPolicy.scss';

interface OwnProps {
  mobile?: true;
  desktop?: true;
  marginBottom?: true;
  className?: string;
}

const ContactInfoPolicy = ({ mobile, desktop, marginBottom, className }: OwnProps) => {
  const [showModal, toggleShowModal] = useToggle(false);

  return (
    <div
      className={cn(styles.contactInfoPolicy, className, {
        [styles.mobile]: mobile,
        [styles.desktop]: desktop,
        [styles.marginBottom]: marginBottom
      })}
    >
      {rm('checkout_contact_integrity_policy_header')}
      &nbsp;
      <Button onClick={toggleShowModal} appearance="link" type="button">
        {rm('checkout_integrity_policy').toLowerCase()}
      </Button>
      {showModal && (
        <CheckoutModal show={showModal} contentClassName={styles.modal}>
          <IntegrityPolicyContent onClose={toggleShowModal} />
        </CheckoutModal>
      )}
    </div>
  );
};

export default ContactInfoPolicy;
